import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, ButtonGroup } from 'reactstrap';
import ReactApexChart from "react-apexcharts";
import { getTendenciaHistorica } from "../../helpers/backend_helper";

const ModalHistoricalChart = ({ isOpen, toggle, metrica, titulo, color = "#405189", codigoProveedor, aseguradora }) => {
    const [datos, setDatos] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [agrupacion, setAgrupacion] = useState('mes'); // dia, semana, mes

    useEffect(() => {
        if (isOpen && metrica) {
            cargarDatos();
        }
    }, [isOpen, metrica, agrupacion, codigoProveedor, aseguradora]);

    const cargarDatos = async () => {
        setCargando(true);
        try {
            const params = { agrupacion };
            if (codigoProveedor) {
                params.codigo_proveedor = codigoProveedor;
            }
            if (aseguradora) {
                params.aseguradora = aseguradora;
            }

            const response = await getTendenciaHistorica(metrica, params);
            setDatos(response.data?.data || []);
        } catch (error) {
            console.error("Error cargando histórico:", error);
        } finally {
            setCargando(false);
        }
    };

    const series = [{
        name: titulo,
        data: datos.map(d => ({
            x: d.fecha,
            y: d.valor
        }))
    }];

    const options = {
        chart: {
            type: 'area',
            height: 350,
            zoom: { enabled: true },
            toolbar: { show: true }
        },
        colors: [color],
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.05,
                stops: [0, 100]
            }
        },
        dataLabels: { enabled: false },
        stroke: {
            curve: 'smooth',
            width: 2
        },
        xaxis: {
            type: 'datetime'
        },
        tooltip: {
            x: { format: 'dd MMM yyyy' }
        },
        grid: {
            borderColor: '#f1f1f1',
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle}>
                Comportamiento Histórico: {titulo}
            </ModalHeader>
            <ModalBody>
                <div className="d-flex justify-content-end mb-3">
                    <ButtonGroup size="sm">
                        <Button 
                            color="primary" 
                            outline 
                            active={agrupacion === 'dia'} 
                            onClick={() => setAgrupacion('dia')}
                        >
                            Diario
                        </Button>
                        <Button 
                            color="primary" 
                            outline 
                            active={agrupacion === 'semana'} 
                            onClick={() => setAgrupacion('semana')}
                        >
                            Semanal
                        </Button>
                        <Button 
                            color="primary" 
                            outline 
                            active={agrupacion === 'mes'} 
                            onClick={() => setAgrupacion('mes')}
                        >
                            Mensual
                        </Button>
                    </ButtonGroup>
                </div>

                {cargando ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                ) : datos.length > 0 ? (
                    <ReactApexChart 
                        options={options} 
                        series={series} 
                        type="area" 
                        height={350} 
                    />
                ) : (
                    <div className="text-center py-5 text-muted">
                        No hay datos históricos disponibles.
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default ModalHistoricalChart;
